import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  users: [],
  loading: false,
  error: "",
  totalPage: 0,
});

const getDepositRequestUrl = (userId) => {
  if (!userId) return `v1/cms/deposit/request`;
  return `v1/cms/deposit/request/${userId}`;
};
export default {
  namespaced: true,

  state: initState(),

  mutations: {
    SET_USERS: (s, users) => (s.users = users),
    SET_TOTAL_PAGE: (s, totalPage) => (s.totalPage = totalPage),
    LOADING: (s) => Object.assign(s, initState(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getDepositRequests({ commit }, { userId, ...params }) {
      commit("LOADING");
      try {
        const url = getDepositRequestUrl(userId);
        const res = await this.$api.get(url, {
          params,
        });
        const data = res?.data;
        if (!data) throw new Error();
        const { total = 0 } = data.pagination || {};
        commit("SET_TOTAL_PAGE", total);
        return data?.data ?? [];
      } catch (e) {
        errorHandler("Lấy dánh sách yêu cầu chuyển tiền thất bại!");
      } finally {
        commit("LOADED");
      }
    },
  },
};
